import { render, staticRenderFns } from "./TabsModal.vue?vue&type=template&id=fdbf36f6&"
import script from "./TabsModal.vue?vue&type=script&lang=js&"
export * from "./TabsModal.vue?vue&type=script&lang=js&"
import style0 from "./TabsModal.vue?vue&type=style&index=0&id=fdbf36f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports